<template>
  <v-select
    dense
    :label="$t('select') + ' ' + $tc('agents', 1, {count: ''}) | cap"
    v-model="agentTmp"
    :items="colleagues"
    item-value="USR_ID"
    return-object
    @input="$emit('update:agent', agentTmp)"
    :disabled="disabled"
    :persistent-hint="hint.trim().length > 0"
    :hint="hint"
  >
    <template slot="selection" slot-scope="data">
      <v-chip small>
        <wz-avatar
          size="28px"
          :src="`${domaine}/public/media/user/small/${data.item.USR_ID}_avatar.jpg`"
          :username="data.item.USR_FIRST_NAME + ' ' + data.item.USR_LAST_NAME"
        ></wz-avatar>
        {{ data.item.USR_FIRST_NAME }} {{ data.item.USR_LAST_NAME }}
        <span v-if="data.item.USR_ID == $store.state._User.id" class="ml-1">({{ $t('me') }})</span>
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <wz-avatar
        size="28px"
        :src="`${domaine}/public/media/user/small/${data.item.USR_ID}_avatar.jpg`"
        :username="data.item.USR_FIRST_NAME + ' ' + data.item.USR_LAST_NAME"
      ></wz-avatar>
      <div class="input-group__selections__comma">
        {{ data.item.USR_FIRST_NAME }} {{ data.item.USR_LAST_NAME }}
        <span v-if="data.item.USR_ID == $store.state._User.id" class="ml-1">({{ $t('me') }})</span>
      </div>
    </template>
  </v-select>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
export default {
  props: {
    agent: {
      type: Object,
      required: true
    },
    init: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Indique si l'agent connecté peut se sélectionner
     */
    withoutMe: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      domaine: DOMAINE,
      agentTmp: null,
      colleagues: []
    }
  },

  created () {
    if (this.init) {
      this.colleagues = _.cloneDeep(this.$store.state._User.colleagues)
      this.agentTmp = _.find(this.colleagues, {
        USR_ID: this.init.USR_ID
      })
    } else if (this.withoutMe) {
      console.log('withoutMe')
      this.colleagues = this.$store.state._User.colleagues.filter(
        colleague => colleague.USR_ID !== this.$store.state._User.id
      )
      this.agentTmp = this.colleagues[0]
    } else {
      this.colleagues = _.cloneDeep(this.$store.state._User.colleagues)
      this.agentTmp = _.find(this.colleagues, {
        USR_ID: this.$store.state._User.id
      })
    }
    this.$emit('update:agent', this.agentTmp)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectAgent.vue